export default __webpack_public_path__ + "static/media/playlist-play-icon.f8ee6f0d.svg";